import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { /*convertListsToEditorIndentList,*/ convertFromTreeToFlatList } from './custom-extensions/PasteConverter/listConvertionUtils';
import TextEditor from './TextEditor';

const TextEditorWrapper = ({
  initialContent,
  content,
  entityId,
  entityType,
  large,
  placeholder,
  onChange,
  onSubmit,
  mentionOptions,
  showMentionOptions,
  textEditorRef
 }) => {
  const convertedInitialContent = useMemo(() => convertFromTreeToFlatList(initialContent, true) || '', [initialContent]);

  const [editorContent, setEditorContent] = useState(convertedInitialContent);

  useEffect(() => {
    if (!content) {
      setEditorContent('');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  useEffect(() => {
    // If no changes were made but save button is pressed, the content, which goes to prepareContentForSending must always be flatten list
    if (onChange && typeof onChange === 'function') {
      onChange(convertedInitialContent);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = useCallback((changedContent, trimmedContent) => {
    setEditorContent(changedContent);
    if (onChange && typeof onChange === 'function') {
      onChange(changedContent, trimmedContent);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextEditor
      editorContent={editorContent}
      entityId={entityId}
      entityType={entityType}
      large={large}
      placeholder={placeholder}
      onChange={handleChange}
      onSubmit={onSubmit}
      mentionOptions={mentionOptions}
      showMentionOptions={showMentionOptions}
      textEditorRef={textEditorRef}
    />
  );
}

export default TextEditorWrapper;
